import '../instrument'
import '../bones/setup'
import '../bones/registry'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import { setupDocumentEngine } from './setup-document-engine'

// if (typeof window !== 'undefined') {
//   scan({
//     enabled: true,
//     log: true
//   })
// }

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools()
}

setupDocumentEngine()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('No existe el elemento #root en index.html')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, eventId }) => (
        <div style={{ padding: 24, fontFamily: 'system-ui' }}>
          <h1 style={{ fontSize: 24, fontWeight: 700 }}>Algo salió mal</h1>
          <p>
            El error fue reportado a nuestro equipo. Podés contactarnos con el ID de incidente:{' '}
            <code>{eventId}</code>
          </p>
          <details style={{ marginTop: 16 }}>
            <summary>Detalles técnicos</summary>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
              {error instanceof Error ? `${error.name}: ${error.message}` : String(error)}
            </pre>
          </details>
          <button
            type="button"
            onClick={() => {
              window.location.href = '/'
            }}
            style={{
              marginTop: 16,
              padding: '8px 16px',
              border: '1px solid #888',
              borderRadius: 4,
              cursor: 'pointer'
            }}
          >
            Volver al inicio
          </button>
        </div>
      )}
      showDialog={false}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
